
import React, { useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles, Button } from '@material-ui/core'
import { Context } from '../../../Store'
import { useTranslation } from 'react-i18next'
import { BOOKING_STATUS, ISO_3166_ITALY_COUNTRY_CODE } from '../../../constants'

export const BackButton = () => {
  const [{current_step, booking, nationality}, dispatch] = useContext(Context)
  const showFlexibilityOptions = useMemo(() => !!booking.has_zappy_flex_plan, [booking.has_zappy_flex_plan])
  const history = useHistory()
  const { t } = useTranslation()
  const styleClasses = useStyles()

  const onClickBack = () => {
    if (!showFlexibilityOptions && current_step === 4) {
      dispatch({ type: 'SET_CURRENT_STEP', payload: 2})
      history.replace(`/bookings/${booking.id}/2`)
    }
    else if (nationality && nationality !== ISO_3166_ITALY_COUNTRY_CODE && current_step === 4) {
      dispatch({ type: 'SET_CURRENT_STEP', payload: 2})
      history.replace(`/bookings/${booking.id}/2`)
    } else {
      dispatch({ type: 'SET_CURRENT_STEP', payload: current_step === 1 ? 1 : (current_step - 1)})
      history.replace(`/bookings/${booking.id}/${current_step - 2}`)
    }
  }
  
  return (
    <Button
      variant="outlined"
      size="large"
      type="button"
      onClick={onClickBack}
      disabled={current_step === 1 || booking.status === BOOKING_STATUS.PENDING}
      className={styleClasses.backButton}
      style={{ color: '#0C9D9D', borderColor: '#0C9D9D' }}
    >
      {t('form.back')}
    </Button>
  )
}

const useStyles = makeStyles((theme) => ({
  backButton: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }
}));